import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Reveal from '@/components/feature/Reveal';
import { useTranslation } from 'react-i18next';

type Block = { type: 'p' | 'li'; text: string };
type Section = { title: string; blocks: Block[] };

export default function Terms() {
  const { t } = useTranslation();
  const sections = t('terms.sections', { returnObjects: true }) as Section[];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 pb-12 bg-background-50">
        <div className="w-full px-4 md:px-6 pt-16 md:pt-24 pb-12">
          <div className="max-w-3xl mx-auto text-center">
            <Reveal>
              <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-50 text-accent-700 text-xs font-semibold mb-5">
                <i className="ri-file-text-line"></i>
                {t('terms.badge')}
              </span>
            </Reveal>
            <Reveal delay={80}>
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-5">
                {t('terms.title')}
              </h1>
            </Reveal>
            <Reveal delay={160}>
              <p className="text-foreground-500 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
                {t('terms.updated')}
              </p>
            </Reveal>
          </div>
        </div>

        <div className="w-full px-4 md:px-6 pb-20">
          <div className="max-w-3xl mx-auto flex flex-col gap-6">
            {sections.map((section, index) => (
              <Reveal key={section.title} delay={index * 40}>
                <section className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
                  <h2 className="font-heading text-lg md:text-xl font-bold text-foreground-950 mb-4">
                    {section.title}
                  </h2>
                  <div className="flex flex-col gap-3">
                    {section.blocks.map((block, blockIndex) => {
                      if (block.type === 'li') {
                        return (
                          <div key={blockIndex} className="flex items-start gap-3">
                            <div className="w-5 h-5 flex items-center justify-center mt-0.5 text-primary-500">
                              <i className="ri-checkbox-blank-circle-fill text-[6px]"></i>
                            </div>
                            <p className="text-foreground-700 text-sm leading-relaxed">{block.text}</p>
                          </div>
                        );
                      }
                      return (
                        <p key={blockIndex} className="text-foreground-700 text-sm leading-relaxed">
                          {block.text}
                        </p>
                      );
                    })}
                  </div>
                </section>
              </Reveal>
            ))}
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}